import { Component, Inject } from "@angular/core";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialog, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'smartlink360-view-activation-details',
    template:require('./smartlink360-view-activation-details.component.html'),
    styles:[require('./smartlink360-view-activation-details.component.css')]
})
export class SmartLink360ViewActivationDetailComponent{
    SelectedLicenseDetail;
    ActivationDetail;
    Smartlink360PurchaseLicenseData;
    dialogTitle='View Activation Details'
    error='';
    errorMessage='';
    isLoading=false;
    constructor(
        private appLoader:AppLoaderService,
        private licenseService:LicenseService,
        private dialogRef:MdDialogRef<SmartLink360ViewActivationDetailComponent>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseDetail=this.dialogData.SelectedLicenseData;
        this.Smartlink360PurchaseLicenseData=this.dialogData.Smartlink360PurchaseLicenseData;
        this.getActivationDetails();
    }
    getActivationDetails(){
        this.isLoading=true;
        this.licenseService.viewSmartLink360ActivationHistory(this.SelectedLicenseDetail.LicenseId).subscribe((data)=>{
           if(!data.IsError && data.DataObject!=null){
                this.ActivationDetail=data.DataObject;
                this.error='';
           }
           else{
            this.error=data.Error;
           }
           this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/smartlink360-view-activation-details/smartlink360-view-activation-details.component.ts